import React from "react";
import Reveal from "./Reveal";
import { evolution } from "../mock";

const EvolutionSection = () => {
  return (
    <section className="bg-white py-14 md:py-20">
      {/* Intro */}
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal className="mx-auto max-w-3xl text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#B8862F]">
            {evolution.eyebrow}
          </span>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-[#0F2A4A] md:text-4xl">
            {evolution.heading}
          </h2>
          <p className="mt-5 text-lg font-light leading-relaxed text-slate-600">
            {evolution.intro}
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-slate-500">
            {evolution.intro2}
          </p>
        </Reveal>
      </div>

      {/* Cinematic video band (contained 16:9 so nothing overshoots/cuts) */}
      <div className="mx-auto my-12 max-w-6xl px-4 md:px-8">
        <div className="relative aspect-video overflow-hidden rounded-2xl bg-[#0b2038] shadow-xl">
          <video
            src={evolution.bgVideoUrl}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            className="absolute inset-0 h-full w-full object-cover"
            data-testid="evolution-bg-video"
          />
          <div className="absolute inset-0 bg-[#0b2038]/35" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0b2038]/90 via-transparent to-transparent" />
          <div className="relative flex h-full flex-col items-center justify-end px-6 pb-8 text-center">
            <span className="text-xs font-semibold uppercase tracking-[0.3em] text-[#B8862F]">
              {evolution.bgEyebrow}
            </span>
            <p className="mt-4 max-w-3xl font-serif-display text-2xl leading-snug text-white md:text-4xl">
              {evolution.bgLine}
            </p>
          </div>
        </div>
      </div>

      {/* Timeline */}
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="relative">
          <div className="absolute left-0 right-0 top-[22px] hidden h-px bg-slate-200 lg:block" />
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
            {evolution.steps.map((s, i) => (
              <Reveal key={s.year} delay={i * 120}>
                <div className="relative">
                  <div className="mb-6 flex items-center gap-3 lg:block">
                    <span className="relative z-10 flex h-11 w-11 items-center justify-center rounded-full border-2 border-[#0F2A4A] bg-white">
                      <span className="h-2.5 w-2.5 rounded-full bg-[#B8862F]" />
                    </span>
                  </div>
                  <div className="text-2xl font-bold text-[#0F2A4A]">{s.year}</div>
                  <h3 className="mt-2 text-lg font-semibold leading-snug text-[#16233B]">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-600">
                    {s.text}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal className="mt-12 text-center">
          <p className="mx-auto max-w-2xl text-lg font-light text-[#0F2A4A]">
            The result is a single ecosystem built for how business works today.
          </p>
          <div className="mx-auto mt-6 h-10 w-px bg-slate-200" />
        </Reveal>
      </div>
    </section>
  );
};

export default EvolutionSection;
